// --- CSS --- //
import "../styles/slider.css";

const Slider = ({ status, onToggle }) => {
    return (
        <label className="switch">
            <input 
                type="checkbox" 
                checked={status} 
                onChange={onToggle}
            />
            <span className="slider round"></span>
        </label>
    );
};

export default Slider;